export enum cardStatus {
    draft = 0,
    published = 2,
    blocked = 4,
    deleted = 5,
    archive = 6,
    awaitPayment = 7,
}export enum cardStatus {
    draft = 0,
    published = 2,
    blocked = 4,
    deleted = 5,
    archive = 6,
    awaitPayment = 7,
}